import React, { useRef, useState, useEffect } from 'react';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';

function ImageCropper({ image, onCropComplete, width, height, padding, coverStyle }) {

    // console.log('width, height, padding', width, height, padding, coverStyle);

    const cropperRef = useRef(null);
    const [croppedImage, setCroppedImage] = useState(null);
    const [croppedBlob, setCroppedBlob] = useState(null);

    useEffect(() => {
        const cropper = cropperRef.current?.cropper;
        if (cropper) {
            // cropper.setCropBoxData({
            //     width: width,
            //     height: height,
            // });

            const canvasData = cropper.getCanvasData();
            const cropWidth = width - 2 * padding; // Adjust for padding
            const cropHeight = height - 2 * padding;

            // console.log('canvasData', canvasData);
            // console.log('cropWidth', cropWidth);
            // console.log('cropHeight', cropHeight);

            cropper.setCropBoxData({
                left: (canvasData.width - cropWidth) / 2,
                top: (canvasData.height - cropHeight) / 2,
                width: cropWidth,
                height: cropHeight,
            });
        }
    }, [image, width, height, padding]);

    const handleCrop = () => {
        const cropper = cropperRef.current?.cropper;
        if (cropper) {
            cropper.getCroppedCanvas({
                width: width,
                height: height,
                // imageSmoothingQuality: 'high',
            }).toBlob((blob) => {
                if (blob) {
                    const croppedFile = new File([blob], 'cropped-image.png', { type: 'image/png' });
                    setCroppedBlob(croppedFile);
                    setCroppedImage(URL.createObjectURL(blob));
                }
            }, 'image/png');
        }
    };

    // const handleCrop = () => {
    //     const cropper = cropperRef.current?.cropper;
    //     if (cropper) {
    //         const imageData = cropper.getImageData(); // Original image dimensions
    //         cropper.getCroppedCanvas({
    //             width: imageData.naturalWidth, // Ensure high resolution
    //             height: imageData.naturalHeight,
    //             imageSmoothingQuality: 'high',
    //         }).toBlob((blob) => {
    //             if (blob) {
    //                 const croppedFile = new File([blob], 'cropped-image.png', { type: 'image/png' });
    //                 setCroppedBlob(croppedFile);
    //                 setCroppedImage(URL.createObjectURL(blob));
    //             }
    //         }, 'image/png');
    //     }
    // };

    return (
        <div style={{ position: 'relative', ...coverStyle }}>
            <Cropper
                ref={cropperRef}
                style={{ height: 400, width: '100%', objectFit: 'cover', ...coverStyle, }}
                initialAspectRatio={width / height}
                src={image}
                crop={handleCrop}
                viewMode={1}
                minCropBoxHeight={10}
                minCropBoxWidth={10}
                background={false}
                responsive={true}
                autoCropArea={1}
                checkOrientation={false}
                guides={false}
                cropBoxResizable={true}
                dragMode='none'
            />
            {croppedImage && (
                <div className='text-center'>
                    {/* <img src={croppedImage} alt="Cropped" style={{ width: `${width}px`, height: `${height}px` }} /> */}
                    <button className='submit_btn mt-5' onClick={() => onCropComplete(croppedBlob)}>Crop</button>
                </div>
            )}
        </div>
    );
}

export default ImageCropper;